import { render } from "./PaymentsDialog.vue?vue&type=template&id=714a10d4"
import script from "./PaymentsDialog.vue?vue&type=script&lang=js"
export * from "./PaymentsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__